<template>
  <div class="navbar-single">
    <div v-if="item" class="content">
      <v-card id="media" class="mx-auto">
        <v-img @load="loading = false" :aspect-ratio="16/9" lazy-src="@/assets/placeholder.png" :key="item.id" :src="photo(item)">
          <v-btn icon class="bottom-icon white" @click.stop="enlarge()">
            <v-icon>mdi-image-size-select-actual</v-icon>
          </v-btn>
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        <v-btn icon id="close" class="white" @click.stop="close()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-list-item>
          <v-list-item-content>
            <h1 v-if="item.title" class="headline">{{item.title}}</h1>
            <div v-if="item.meta.geistliche_zugehorigkeit">{{ item.meta.geistliche_zugehorigkeit.join() }}</div>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn small color="info" :href="item.permalink" title="Mehr erfahren">
            Mehr erfahren
          </v-btn>
          <v-item-group>
            <v-item>
              <Share :item="item" />
            </v-item>
          </v-item-group>
        </v-card-actions>
        <v-divider></v-divider>               
        <v-card-text v-if="item.description" v-html="item.description" />
        <v-card-text v-if="item.meta.ordensbezirk">
          <h5>Ordensbezirk</h5>{{item.meta.ordensbezirk}}
        </v-card-text>
        <v-list dense>
          <v-list-item v-if="(item.meta.grundungsdatum || item.meta.grundungsdatum_text)">
            <v-list-item-action>
              <v-icon>mdi-calendar-clock</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Gründung</v-list-item-title>
              <v-list-item-subtitle v-if="item.meta.grundungsdatum_text">{{ item.meta.grundungsdatum_text }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.meta.grundungsdatum">{{ formatDate(item.meta.grundungsdatum) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider inset></v-divider>
          <v-list-item v-if="(item.meta.aufhebungsdatum || item.meta.aufhebungsdatum_text)">
            <v-list-item-action>&nbsp;</v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Aufhebung</v-list-item-title>
              <v-list-item-subtitle v-if="item.meta.aufhebungsdatum_text">{{ item.meta.aufhebungsdatum_text }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="item.meta.aufhebungsdatum">{{ formatDate(item.meta.aufhebungsdatum) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider inset></v-divider>
          <v-list-item @click="centerMapToCurrent">
            <v-list-item-action>
              <v-icon>mdi-map-marker</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.meta.ortslage }}</v-list-item-title>
              <v-list-item-subtitle>{{ item.location.latlng.lat.toFixed(6) }}, {{ item.location.latlng.lng.toFixed(6) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-subheader v-if="item.category">{{ $t('sidenav.single.category') }}</v-subheader>
          <v-chip v-for="cat in item.category" :key="cat.id" class="ma-2"
          outlined
          >{{cat.name}}</v-chip>
        <v-subheader v-if="item.tags">Tags</v-subheader>
          <v-chip v-for="tag in item.tags" :key="tag.id"
            color="pink"
            label
            small
            text-color="white"
            class="ma-2"
          >
            <v-icon left>mdi-label</v-icon>
            {{tag.name}}
          </v-chip>
      </v-card>
    </div>
  </div>
</template>

<script>
  import Share from "../Share.vue";
  export default {
    components: {
      Share,
    },
    computed: {
      drawer: {
        get () {
          return this.$store.state.sidenav
        },
        set (val) {
          this.$store.commit('sidenav', val)
        }
      },
    },
    data: () => ({
      item: null,
      loading: true,
    }),
    created () {
      // fetch the data when the view is created and the data is
      // already being observed
      this.fetchData()
    },
    watch: {
      // call again the method if the route changes
      '$route': 'fetchData',
      'drawer': 'fetchData',
    },
    methods: {
      formatDate(date) {
        var d = new Date(date)
        var options = {
          weekday: "short",
          year: "numeric",
          month: "2-digit",
          day: "numeric"
        };
        return d.toLocaleDateString(this.$mmconfig.locale.substring(0,2), options)
      },
      formatPeriod(item) {
        var result = ""
        if(item.meta.grundungsdatum_typ === "text") {
          if(item.meta.grundungsdatum_text !== "") {
            result += item.meta.grundungsdatum_text
          } else {
            result += "?"
          }
        } else {
          result += item.meta.grundungsdatum
        }
        if(item.meta.aufhebungsdatum_typ === "text") {
          if(item.meta.aufhebungsdatum_text !== "") {
            result += " – " + item.meta.aufhebungsdatum_text
          } else {
            result += "?"
          }
        } else {
          result += item.meta.aufhebungsdatum
        }
        return result
      },
      bookmark(item) {
        item.bookmark = !item.bookmark
        if(item.bookmark) {
          this.$store.dispatch('message', { content: this.$i18n.t('sidenav.single.bookmarkAdded'), color: 'success' })
        } else {
          this.$store.dispatch('message', { content: this.$i18n.t('sidenav.single.bookmarkRemoved'), color: 'warning' })
        }
      },
      photo(item) {
        return item.media.standard_resolution.url;
      },
      fetchData () {
        this.loading = true
        this.referer = window.location.href
        this.item = this.$store.state.currentMarker
      },
      close: function() {
        this.drawer = false;
        //this.$store.state.currentMarker.icon.options.className = "";
        this.$store.state.currentMarker = null;
        var el = document.getElementsByClassName("leaflet-marker-icon active");
        while (el.length) {
          el[0].classList.remove("active");
        }
        this.$emit("close");
      },
      enlarge: function() {
        this.$emit('enlarge-current')
      },
      centerMapToCurrent: function() {
        this.$emit('center-to-current')
      },
    }
  }
</script>

<style lang="scss">
  #media {
    box-shadow: none;
    border-radius: 0;
  }
  audio, video {
    width: 100%;
    height: auto;
  }
  audio {
    align-self: flex-end;
  }
  .header {
    display: flex;
    /* 
    The flex items (.logo and .copy) are vertical, so the flex-
    direction should be column. flex-flow is a combination of
    flex-direction and flex-wrap
    */
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    min-height: 200px;
    background-color: #EEE;
  }

  .header > i {
    margin: auto;
  }

  .bottom-icon {
    position: absolute !important;
    bottom: 0;
    right: 0;
    margin: 10px;
  }
  .v-card__actions .v-btn.v-btn {
    margin: 0 4px;
    //padding: 0 !important;
  }
  audio {
    height: 40px;
    &:focus {
      outline: none;
    }
  }
</style>
